module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('p', {
    staticClass: "title1"
  }, [_vm._v("MARKETS OF "), _c('em', [_vm._v("Provence")])]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_vm._v("Food, Antiques, Crafts, and More")]), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Text and photographs by")]), _vm._v(" "), _c('p', {
    staticClass: "title4"
  }, [_vm._v("Marjorie R. Williams")]), _vm._v(" "), _c('p', {
    staticClass: "title5"
  }, [_vm._v("with Dixon Long")]), _vm._v(" "), _c('p', {
    staticClass: "figure_logo"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/logo.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7049e79c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/tp.vue
// module id = 63
// module chunks = 0